class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.addToCartButton = this.querySelector('.add-to-basket-btn, .add-to-cart-btn, .cart-upsell-btn');
    this.current_variant_id = this.getAttribute('variant-id');
    this.productHandle = this.getAttribute('product-handle');

    // Hent productId fra attribut eller fallback til hidden input
    this.productId = this.getAttribute('product-id');
    if (!this.productId) {
      const hiddenIdInput = this.querySelector('input[name="product-id"]');
      this.productId = hiddenIdInput ? hiddenIdInput.value : null;
    }

    // Find <script> elementet med varianter
    const variantsEl = this.querySelector(`#product-variants-json-${this.productId}`);
    if (!variantsEl) {
      console.error('❌ No variants JSON element found for product', this.productId);
      this.variants = [];
    } else {
      this.variants = JSON.parse(variantsEl.innerText);
    }

    // Sæt currentVariant
    this.currentVariant = this.variants.find((variant) => variant.id == this.current_variant_id);
    // Hvis ikke fundet, vælg første tilgængelige
    if (!this.currentVariant && this.variants.length > 0) {
      this.currentVariant = this.variants.find((v) => v.available) || this.variants[0];
    }
    if (this.currentVariant) {
      console.log('✅ Current variant:', this.currentVariant);
    }

    // Localized labels from data attributes or fallbacks
    const btn = this.addToCartButton;
    this.addToCartLabel =
      (btn && (btn.getAttribute('data-add-to-cart') || btn.dataset?.addToCart)) ||
      (btn && (btn.textContent || '').split('-')[0].trim()) ||
      'Add to cart';
    this.soldOutLabel = (btn && (btn.getAttribute('data-sold-out') || btn.dataset?.soldOut)) || 'Sold out';
  }

  connectedCallback() {
    this._boundHandleSubmit = this.handleFormSubmit.bind(this);
    this._boundUpdateVariant = this.updateVariant.bind(this);

    this.form.addEventListener('submit', this._boundHandleSubmit);
    this.addEventListener('input', this._boundUpdateVariant);

    if (this.querySelector('#main-variant-select')) this.querySelector('#main-variant-select').style.display = 'none';
    if (this.querySelector('.product-variant-options'))
      this.querySelector('.product-variant-options').style.display = 'block';
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this._boundHandleSubmit);
    this.removeEventListener('input', this._boundUpdateVariant);
  }

  // variantFromOptionValues() {
  //     const option1 = this.querySelector('select[name="option1"]')?.value || null;
  //     const option2 = this.querySelector('select[name="option2"]')?.value || null;
  //     const option3 = this.querySelector('select[name="option3"]')?.value || null;

  //     return this.variants.find(variant =>
  //         variant.option1 == option1 &&
  //         variant.option2 == option2 &&
  //         variant.option3 == option3
  //     );
  // }

  // setSelectedOptionsFromVariant() {
  //     if(this.currentVariant) {
  //         if(this.querySelector('select[name="option1"]') && this.currentVariant.option1) this.querySelector('select[name="option1"]').value = this.currentVariant.option1;
  //         if(this.querySelector('select[name="option2"]') && this.currentVariant.option2) this.querySelector('select[name="option2"]').value = this.currentVariant.option2;
  //         if(this.querySelector('select[name="option3"]') && this.currentVariant.option3) this.querySelector('select[name="option3"]').value = this.currentVariant.option3;
  //     }
  // }

  updateVariant() {
    this.currentVariant = this.variants.find(
      (variant) => variant.id == this.querySelector('[name="id"]:checked').value
    );

    // 1. Update history state
    window.history.replaceState({}, '', `/products/${this.productHandle}?variant=${this.currentVariant.id}`);

    // 2. Update image
    document.querySelector('.product-image').src = this.currentVariant.featured_image.src + '&width=400';

    // 3. Update price
    document.querySelector('.product-price').innerText = Shopify.formatMoney(this.currentVariant.price);

    // 4. Update button state
    const inputButton = this.querySelector('button[type="submit"]');
    if (!this.currentVariant.available) {
      inputButton.setAttribute('disabled', '');
      inputButton.textContent = this.soldOutLabel;
    } else {
      if (inputButton.hasAttribute('disabled')) inputButton.removeAttribute('disabled');
      // Only restore base label if we previously set Sold out
      if ((inputButton.textContent || '').trim() === this.soldOutLabel) {
        inputButton.textContent = this.addToCartLabel;
      }
    }
  }

  handleFormSubmit(evt) {
    evt.preventDefault();
    let formData = new FormData(this.form);

    const sideCartEl = document.querySelector('side-cart');
    if (!sideCartEl) {
      console.error('Side cart not initialized yet');
      return;
    }

    sideCartEl.classList.remove('loaded');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((json_response) => {
        if (json_response.status != 'bad_request') {
          sideCartEl.addLineItem(json_response);
        } else {
          alert('Error: ' + json_response.message);
        }
      });
  }
}

customElements.define('product-form', ProductForm);
